import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { RateProfileService } from '@app/_components/rate/rate-profile/';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { CalendarModule } from 'primeng/calendar';
import * as moment from 'moment';

@Component({
    selector: 'app-rate-profile',
    templateUrl: './rate-profile.component.html',
    styleUrls: ['./rate-profile.component.css'],
    standalone: false
})
export class RateProfileComponent implements OnInit
{

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private rateProfileService: RateProfileService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder) { }

	// structure
	subscription: Subscription;
	routerLocation = this.location;


	// data
	rateProfileApiResponse: ApiResponse;
	rateProfile;
	rateProfileId: Number;
	occupancySummary: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;

	validationMessages = {
		'startDate': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '15 characters maximum' }],
		'endDate': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '15 characters maximum' }],
		'effectiveRate': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '15 characters maximum' }],
		'createDate': [{ type: '', message: '' }],
		'lastUpdate': [{ type: '', message: '' }],
		'descriptionOps': [{ type: '', message: '' }],
		'descriptionOwner': [{ type: '', message: '' }],
		'descriptionGuest': [{ type: '', message: '' }],
		'rateType': [{ type: '', message: '' }],
		'currencyType': [{ type: '', message: '' }],
		'defaultRate': [{ type: '', message: '' }],
		'discountRate': [{ type: '', message: '' }],
		'numOfDaysForwardToAnalyze': [{ type: '', message: '' }],
		'numOfDaysBackwardToAnalyze': [{ type: '', message: '' }],
		'discountMaxPercent': [{ type: '', message: '' }],
		'discountLookForwardDays': [{ type: '', message: '' }],
		'discountHeadlineSpecialsLookForwardDays': [{ type: '', message: '' }],
		'discountHeadlineSpecialsMinNightsToAnalyze': [{ type: '', message: '' }],
		'minStayExpected': [{ type: '', message: '' }],
		'avgStayFor': [{ type: '', message: '' }],
		'shortTermGapMultiplier': [{ type: '', message: '' }],
		'shortTermGapPenaltyPercent': [{ type: '', message: '' }],
		'shortTermGapMinNightsReqRev': [{ type: '', message: '' }],
		'longTermGapMultiplier': [{ type: '', message: '' }],
		'longTermGapPenaltyPercent': [{ type: '', message: '' }],
		'connectingFrontOrBackMultiplier': [{ type: '', message: '' }],
		'connectingFrontAndBackMultiplier': [{ type: '', message: '' }],
		'lengthOfStayDiscountFactorOffset': [{ type: '', message: '' }],
		'adjustmentPercent': [{ type: '', message: '' }],
		'adjustmentAmount': [{ type: '', message: '' }],
		'adjustmentNights': [{ type: '', message: '' }],
		'NumNightsStay': [{ type: '', message: '' }],
		'numNightsAvailableInPeriod': [{ type: '', message: '' }],
		'numNightsActuallyEmpty': [{ type: '', message: '' }],
		'numNightsToNextCheckin': [{ type: '', message: '' }],
		'numNightsFromPreviousCheckout': [{ type: '', message: '' }],
		'numNightsLikelyEmpty': [{ type: '', message: '' }],
		'numNightsLikelyEmptyFromPreviousCheckout': [{ type: '', message: '' }],
		'numNightsLikelyEmptyToNextCheckin': [{ type: '', message: '' }],
		'guestSuggestionText': [{ type: '', message: '' }],
		'reservationQuality': [{ type: '', message: '' }],
		'reservationQualityName': [{ type: '', message: '' }],
		'opsNotes': [{ type: '', message: '' }],
		'debug': [{ type: '', message: '' }]
	};


	ngOnInit()
	{

		// formAction
		this.formAction = this.router.url.startsWith('/rate-profile-add') ? 'add' : this.router.url.startsWith('/rate-profile-edit') ? 'edit' : this.router.url.startsWith('/rate-profile-view') ? 'view' : '/';

		/**
				 *
				 *
				 *
				 * DATA
				 *
				*/

		// -------------------------------------------------------------------------------------------------
		// no advanced data handlers
		// -------------------------------------------------------------------------------------------------


		/**
				 *
				 *
				 *
				 * ACTIONS (ADD / EDIT / DETAIL)
				 *
				 */
		try
		{
			// add
			if (this.formAction === 'add')
			{
				this.formLabels['title'] = 'Add New Rate Profile';
				this.formReadOnly = false;
				this.formBuild();
			}

			// edit
			else if (this.formAction === 'edit')
			{

				this.subscription = this.activatedRoute.params.subscribe(params =>
				{
					this.rateProfileId = params.rateProfileId; // (+) converts string 'id' to a number
				});
				this.formLabels['title'] = 'Edit';
				this.formReadOnly = false;
				this.formBuild();

				// get data
				this.rateProfile = this.findById(+this.rateProfileId);

				// patch in data
				this.form1.patchValue(this.rateProfile);
			}

			// view
			else if (this.formAction === 'view')
			{
				this.subscription = this.activatedRoute.params.subscribe(params =>
				{
					this.rateProfileId = params.rateProfileId; // (+) converts string 'id' to a number
				});
				this.formLabels['title'] = '';
				this.formReadOnly = true;
				this.formBuild();

				// get data
				this.rateProfile = this.findById(+this.rateProfileId);

				// patch in data
				this.form1.patchValue(this.rateProfile);
			}
		}
		catch (error)
		{
			console.log('Error: ' + error);
		}
	}




	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;

			this.rateProfileService.add(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('rate-profile-add SUCCESS: ' + JSON.stringify(res));
						this.rateProfileId = res.data.rateProfile.rateProfileId;
						this.router.navigate(['/rate-profile-view', this.rateProfileId]);
					},
					err =>
					{
						console.log('rate-profile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}
			console.log('rate-profile-before-updateS: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;

			this.rateProfileService.update(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('rate-profile-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.router.navigate(['/rate-profile-view', this.rateProfileId]);
					},
					err =>
					{
						console.log('rate-profile-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	findById(id: number)
	{
		try
		{
			this.formLoading = true;
			this.rateProfileService.findById(id)
				.subscribe(
					res =>
					{
						console.log('rate-profile-find SUCCESS: ' + JSON.stringify(res));
						this.rateProfileApiResponse = res;
						this.rateProfile = res.data.rateProfile;
						this.form1.patchValue(this.rateProfile);
					},
					err =>
					{
						console.log('rate-profile-find FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}



	formBuild()
	{
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.form1 = this.formBuilder.group({
			rateProfileId: [this.rateProfileId],
			createDate: [],
			lastUpdate: [],
			startDate: [new Date()],
			endDate: [new Date()],
			descriptionOps: [],
			descriptionOwner: [],
			descriptionGuest: [],
			rateType: [],
			currencyType: [],
			defaultRate: [],
			discountRate: [],
			effectiveRate: [],
			numOfDaysForwardToAnalyze: [],
			numOfDaysBackwardToAnalyze: [],
			discountMaxPercent: [],
			discountLookForwardDays: [],
			discountHeadlineSpecialsLookForwardDays: [],
			discountHeadlineSpecialsMinNightsToAnalyze: [],
			minStayExpected: [],
			avgStayFor: [],
			shortTermGapMultiplier: [],
			shortTermGapPenaltyPercent: [],
			shortTermGapMinNightsReqRev: [],
			longTermGapMultiplier: [],
			longTermGapPenaltyPercent: [],
			connectingFrontOrBackMultiplier: [],
			connectingFrontAndBackMultiplier: [],
			lengthOfStayDiscountFactorOffset: [],
			adjustmentPercent: [],
			adjustmentAmount: [],
			adjustmentNights: [],
			NumNightsStay: [],
			numNightsAvailableInPeriod: [],
			numNightsActuallyEmpty: [],
			numNightsToNextCheckin: [],
			numNightsFromPreviousCheckout: [],
			numNightsLikelyEmpty: [],
			numNightsLikelyEmptyFromPreviousCheckout: [],
			numNightsLikelyEmptyToNextCheckin: [],
			guestSuggestionText: [],
			reservationQuality: [],
			reservationQualityName: [],
			opsNotes: [],
			debug: []


			// name: ['', Validators.compose([Validators.required, Validators.maxLength(15)])],
			// description: ['', Validators.compose([Validators.required, Validators.maxLength(128)])]
		});
	}

}
